import createTracker from './create-tracker';
import { report, getDiffRouteTime } from './report';
const $$tracker = createTracker(report, getDiffRouteTime);

export default $$tracker;
